import './modal-create-staff.scss';
import React, { useState } from 'react';
import Modal from '@mui/material/Modal';
import { Button, Snackbar } from '@mui/material';
import { Box } from '@mui/material';
import apiClient from '../../../../utils/apiClient';
import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';


function ModalCreateStaff({ open, onClose, user, role }) {
  const { t } = useTranslation();
  const token = sessionStorage.getItem('token') || null;
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('');
  const navigate = useNavigate();

  console.log(role)
  const onSubmit = async () => {
    let url = '';
    if (role === 'retailerGM') {
      url = `${process.env.REACT_APP_API_URL}/retailer/staff-general-manager`;
    } else if (role === 'saleperson') {
      url = `${process.env.REACT_APP_API_URL}/retailer/staff-salesperson`;
    }

    const payload = {
      "email": user.email,
      "name": user.name,
      "last_name": user.last_name,
      "prefix_phone": user.prefix_phone,
      "phone": user.phone,
      "preferred_language": user.preferred_language,
      "ids_retailer": user.ids_retailer
    }
    
    try {
      const response = await apiClient.post(
        url,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          }
        }
      );

      // Si la solicitud fue exitosa (status 200 o 201)
      if (response.status === 200) {
        setSnackbarMessage(t('alert-data-saved'));
        setSnackbarOpen(true);
        setSnackbarSeverity('success');
        setTimeout(() => {
          navigate(-1);
        }, 2000);
      }

    } catch (error) {
      if (error.response) {
        if (error.response.status === 400) {
          console.error("Solicitud incorrecta: ", error.response.data);
        } else if (error.response.status === 409) {
          setSnackbarMessage(t('alert-duplicate'));
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        } else {
          console.error("Error inesperado: ", error);
          // Mostrar el mensaje de error en el snackbar
          setSnackbarMessage(t('common-internal-server-error'));
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        }

      }
    }
  };



  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        closeAfterTransition
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="modal-confirm-retailerGM"
      >
        <Box className="box-confirmation">
          <button className="close" onClick={onClose}>
            <span className="icon-close"></span>
          </button>
          <div className="box-content">
            <h2>
              {t('admin-new-retailerGM-modal-title')}
              {role === 'retailerGM' && t('common-role-retailerGM')}
              {role === 'saleperson' && t('common-role-saleperson')}
            </h2>
            <p>{t('admin-new-retailerGM-modal-retailer-text') + ':'}<br/> <strong>{user?.retailer_name}</strong></p>
            <p><strong>{user?.name} {user?.last_name}</strong><br/>{user?.email}</p>
            <div className="modal-buttons">
              <Button variant="contained" className="btn button-mod cancel-mod" onClick={onClose}>
                {t('common-cancel')}
              </Button>
              <Button variant="contained" className="btn button-mod confirm-mod" onClick={onSubmit}>
                {t('modal-confirm-nomination')}
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
      >
        <Alert severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
}

export default ModalCreateStaff;
